import AdminInstance from 'modules/admin/repository';
import { apiDownloadFile } from 'modules/actions';
import { API_ADMIN_FUNDS_EXCEL, API_ADMIN_FUNDS_EXCEL_TEMPLATE } from 'modules/apiEndpoints';

export const getFunds = (page, size, search, filters, sort) => AdminInstance.getAdminFunds({
  page, size, search, filters, sort,
});

export const createFund = (fund) => AdminInstance.postAdminFund({ ...fund });

export const editFund = (id, fund) => AdminInstance.putAdminFund(id, { ...fund });

export const deleteFund = (fund) => AdminInstance.deleteAdminFund(fund);

export const createFundMassive = (file) => AdminInstance.createFundMassive(file);

export const downloadExcelFunds = async (filename) => apiDownloadFile(API_ADMIN_FUNDS_EXCEL, filename);

export const downloadExcelFundsTemplate = (filename) => apiDownloadFile(API_ADMIN_FUNDS_EXCEL_TEMPLATE, filename);
